var map = {
	"./additional-event-properties/sources.ts": [
		"./projects/demos/app/demo-modules/additional-event-properties/sources.ts",
		"common",
		12
	],
	"./all-day-events/sources.ts": [
		"./projects/demos/app/demo-modules/all-day-events/sources.ts",
		"common",
		13
	],
	"./async-events/sources.ts": [
		"./projects/demos/app/demo-modules/async-events/sources.ts",
		"common",
		14
	],
	"./before-view-render/sources.ts": [
		"./projects/demos/app/demo-modules/before-view-render/sources.ts",
		"common",
		15
	],
	"./clickable-days/sources.ts": [
		"./projects/demos/app/demo-modules/clickable-days/sources.ts",
		"common",
		16
	],
	"./clickable-events/sources.ts": [
		"./projects/demos/app/demo-modules/clickable-events/sources.ts",
		"common",
		17
	],
	"./context-menu/sources.ts": [
		"./projects/demos/app/demo-modules/context-menu/sources.ts",
		"common",
		18
	],
	"./custom-event-class/sources.ts": [
		"./projects/demos/app/demo-modules/custom-event-class/sources.ts",
		"common",
		19
	],
	"./custom-templates/sources.ts": [
		"./projects/demos/app/demo-modules/custom-templates/sources.ts",
		"common",
		20
	],
	"./customise-date-formats/sources.ts": [
		"./projects/demos/app/demo-modules/customise-date-formats/sources.ts",
		"common",
		4
	],
	"./dark-theme/sources.ts": [
		"./projects/demos/app/demo-modules/dark-theme/sources.ts",
		"common",
		5
	],
	"./day-view-hour-split/sources.ts": [
		"./projects/demos/app/demo-modules/day-view-hour-split/sources.ts",
		"common",
		21
	],
	"./day-view-scheduler/sources.ts": [
		"./projects/demos/app/demo-modules/day-view-scheduler/sources.ts",
		"common",
		3
	],
	"./day-view-start-end/sources.ts": [
		"./projects/demos/app/demo-modules/day-view-start-end/sources.ts",
		"common",
		22
	],
	"./demo-utils/sources.ts": [
		"./projects/demos/app/demo-modules/demo-utils/sources.ts"
	],
	"./disable-slide-animation/sources.ts": [
		"./projects/demos/app/demo-modules/disable-slide-animation/sources.ts",
		"common",
		23
	],
	"./disable-tooltips/sources.ts": [
		"./projects/demos/app/demo-modules/disable-tooltips/sources.ts",
		"common",
		6
	],
	"./drag-to-create-events/sources.ts": [
		"./projects/demos/app/demo-modules/drag-to-create-events/sources.ts",
		"common",
		24
	],
	"./draggable-events/sources.ts": [
		"./projects/demos/app/demo-modules/draggable-events/sources.ts",
		"common",
		25
	],
	"./draggable-external-events/sources.ts": [
		"./projects/demos/app/demo-modules/draggable-external-events/sources.ts",
		"common",
		26
	],
	"./editable-deletable-events/sources.ts": [
		"./projects/demos/app/demo-modules/editable-deletable-events/sources.ts",
		"common",
		27
	],
	"./exclude-days/sources.ts": [
		"./projects/demos/app/demo-modules/exclude-days/sources.ts",
		"common",
		28
	],
	"./extra-month-view-weeks/sources.ts": [
		"./projects/demos/app/demo-modules/extra-month-view-weeks/sources.ts",
		"common",
		29
	],
	"./group-month-view-events/sources.ts": [
		"./projects/demos/app/demo-modules/group-month-view-events/sources.ts",
		"common",
		30
	],
	"./i18n/sources.ts": [
		"./projects/demos/app/demo-modules/i18n/sources.ts",
		"common",
		7
	],
	"./kitchen-sink/sources.ts": [
		"./projects/demos/app/demo-modules/kitchen-sink/sources.ts",
		8
	],
	"./min-max-date/sources.ts": [
		"./projects/demos/app/demo-modules/min-max-date/sources.ts",
		"common",
		9
	],
	"./moment/sources.ts": [
		"./projects/demos/app/demo-modules/moment/sources.ts",
		"common",
		31
	],
	"./month-view-badge-total/sources.ts": [
		"./projects/demos/app/demo-modules/month-view-badge-total/sources.ts",
		"common",
		32
	],
	"./navigating-between-views/sources.ts": [
		"./projects/demos/app/demo-modules/navigating-between-views/sources.ts",
		"common",
		33
	],
	"./no-events-label/sources.ts": [
		"./projects/demos/app/demo-modules/no-events-label/sources.ts",
		"common",
		34
	],
	"./optional-event-end-dates/sources.ts": [
		"./projects/demos/app/demo-modules/optional-event-end-dates/sources.ts",
		"common",
		35
	],
	"./recurring-events/sources.ts": [
		"./projects/demos/app/demo-modules/recurring-events/sources.ts",
		"common",
		36
	],
	"./refreshing-the-view/sources.ts": [
		"./projects/demos/app/demo-modules/refreshing-the-view/sources.ts",
		"common",
		37
	],
	"./resizable-events/sources.ts": [
		"./projects/demos/app/demo-modules/resizable-events/sources.ts",
		"common",
		38
	],
	"./selectable-period/sources.ts": [
		"./projects/demos/app/demo-modules/selectable-period/sources.ts",
		"common",
		39
	],
	"./show-dates-on-titles/sources.ts": [
		"./projects/demos/app/demo-modules/show-dates-on-titles/sources.ts",
		"common",
		10
	],
	"./week-view-minute-precision/sources.ts": [
		"./projects/demos/app/demo-modules/week-view-minute-precision/sources.ts",
		"common",
		40
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./projects/demos/app/demo-modules lazy recursive ^\\.\\/.*\\/sources\\.ts$";
module.exports = webpackAsyncContext;